(() => {
  const STORAGE_PREFIX = 'novapans_latam_landing_variant';
  let lastScaleVideoTrigger = null;

  function publish(name, payload) {
    if (
      window.Shopify &&
      Shopify.analytics &&
      typeof Shopify.analytics.publish === 'function'
    ) {
      Shopify.analytics.publish(name, payload);
    }
  }

  function chooseVariant(root) {
    const country = root.dataset.country || 'LATAM';
    const enabled = root.dataset.experimentEnabled === 'true';
    const storageKey = `${STORAGE_PREFIX}_${country}`;
    let variant = 'A';
    let newlyAssigned = false;

    if (enabled) {
      let saved = null;
      try {
        saved = localStorage.getItem(storageKey);
      } catch (_error) {
        saved = null;
      }
      if (saved === 'A' || saved === 'B') {
        variant = saved;
      } else {
        variant = Math.random() < 0.5 ? 'A' : 'B';
        try {
          localStorage.setItem(storageKey, variant);
        } catch (_error) {
          // Continue with an ephemeral assignment when storage is unavailable.
        }
        newlyAssigned = true;
      }
    }

    root.dataset.activeVariant = variant;
    root.querySelectorAll('[data-latam-variant]').forEach((element) => {
      element.hidden = element.dataset.latamVariant !== variant;
    });

    const basePayload = {
      country_code: country,
      landing_variant: variant,
      experiment_enabled: enabled,
    };

    if (newlyAssigned) {
      publish('novapans:latam_experiment_assigned', basePayload);
    }
    publish('novapans:latam_landing_view', basePayload);

  }

  function bindActionTracking() {
    if (document.documentElement.dataset.latamActionTrackingReady === 'true') return;
    document.documentElement.dataset.latamActionTrackingReady = 'true';

    document.addEventListener('click', (event) => {
      const target = event.target.closest && event.target.closest('[data-latam-action]');
      if (!target) return;
      const root = document.querySelector('.latam-landing');
      if (!root) return;
      publish('novapans:latam_cta_clicked', {
        country_code: root.dataset.country || 'LATAM',
        landing_variant: root.dataset.activeVariant || 'A',
        experiment_enabled: root.dataset.experimentEnabled === 'true',
        action: target.dataset.latamAction,
        product_id: target.dataset.productId || null,
      });
    });
  }

  function closeScaleVideoDialog(dialog) {
    const frame = dialog.querySelector('[data-latam-scale-video-frame]');
    const video = frame && frame.querySelector('video');
    if (video) video.pause();
    if (frame) frame.replaceChildren();
    if (dialog.open) dialog.close();
    if (lastScaleVideoTrigger) lastScaleVideoTrigger.focus();
  }

  function bindScaleVideoDialog() {
    if (document.documentElement.dataset.latamScaleVideoReady === 'true') return;
    const dialog = document.querySelector('#LatamScaleVideoDialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    document.documentElement.dataset.latamScaleVideoReady = 'true';
    const title = dialog.querySelector('#LatamScaleVideoTitle');
    const frame = dialog.querySelector('[data-latam-scale-video-frame]');

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest && event.target.closest('[data-latam-scale-video]');
      if (trigger) {
        lastScaleVideoTrigger = trigger;
        title.textContent = trigger.dataset.videoTitle || 'Escucha esta escala';
        frame.replaceChildren();
        if (trigger.dataset.videoKind === 'youtube') {
          const iframe = document.createElement('iframe');
          iframe.src = trigger.dataset.videoSrc;
          iframe.title = title.textContent;
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
          iframe.allowFullscreen = true;
          frame.append(iframe);
        } else {
          const video = document.createElement('video');
          video.src = trigger.dataset.videoSrc;
          video.controls = true;
          video.autoplay = true;
          video.playsInline = true;
          frame.append(video);
        }
        dialog.showModal();
        return;
      }
      if (event.target.closest && event.target.closest('[data-latam-scale-video-close]')) {
        closeScaleVideoDialog(dialog);
      } else if (event.target === dialog) {
        closeScaleVideoDialog(dialog);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && dialog.open) {
        event.preventDefault();
        closeScaleVideoDialog(dialog);
      }
    });
  }

  function initialise() {
    document.querySelectorAll('.latam-landing:not([data-measurement-ready])').forEach((root) => {
      root.dataset.measurementReady = 'true';
      document.documentElement.classList.add('latam-market-active');
      chooseVariant(root);
    });
    bindActionTracking();
    bindScaleVideoDialog();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', initialise);
})();
